import React, { useState, useEffect } from "react";
import Icon from "./AppIcon";
import {
  jaRespondeuConsentimento,
  registrarConsentimento,
} from "utils/consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (!jaRespondeuConsentimento()) {
      // Atraso suave para não competir com o carregamento inicial
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  // registrarConsentimento troca o modo do PostHog e liga/desliga o Firebase
  // Analytics na hora; antes a escolha era só gravada e ninguém a lia.
  const persist = (accepted) => {
    registrarConsentimento(accepted);
    setVisible(false);
  };

  const accept = () => persist(true);
  const decline = () => persist(false);

  if (!visible) return null;

  return (
    // No mobile o banner ficava com 307px (46% de um iPhone SE) e chegava a
    // cobrir o botão "Próximo" do cadastro, travando o funil. Agora o texto é
    // enxuto por padrão, os detalhes vão para um bloco rolável opcional e a
    // barra respeita a área segura do indicador de home.
    <div
      className="fixed bottom-0 left-0 right-0 z-[9000] p-3 md:p-6 pb-safe-3 md:pb-6"
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <div className="max-w-4xl mx-auto bg-card border border-border rounded-2xl shadow-2xl">
        <div className="p-4 md:p-6">
          <div className="flex items-start gap-3 md:gap-4">
            {/* Ícone — escondido no mobile para ganhar largura de texto */}
            <div className="hidden sm:flex w-10 h-10 bg-primary/10 rounded-xl items-center justify-center flex-shrink-0 mt-0.5">
              <Icon name="Cookie" size={20} className="text-primary" />
            </div>

            {/* Conteúdo */}
            <div className="flex-1 min-w-0">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 md:gap-4">
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground text-sm mb-1 flex items-center gap-2">
                    <Icon
                      name="Cookie"
                      size={16}
                      className="text-primary sm:hidden"
                    />
                    Cookies e privacidade
                  </h3>
                  <p className="text-xs text-muted-foreground leading-relaxed">
                    Usamos cookies essenciais e, com seu consentimento,
                    analíticos — conforme a LGPD.{" "}
                    <button
                      onClick={() => setShowDetails(!showDetails)}
                      className="text-primary underline underline-offset-2 font-medium"
                      aria-expanded={showDetails}
                    >
                      {showDetails ? "Ocultar detalhes" : "Saiba mais"}
                    </button>
                  </p>

                  {/* Detalhes expandíveis — rolável para nunca estourar a tela */}
                  {showDetails && (
                    <div className="mt-3 space-y-2 bg-muted/40 rounded-lg p-3 max-h-[28vh] overflow-y-auto overscroll-contain">
                      <div className="flex items-start space-x-2">
                        <Icon
                          name="CheckCircle"
                          size={14}
                          className="text-success mt-0.5 flex-shrink-0"
                        />
                        <div>
                          <p className="text-xs font-medium text-foreground">
                            Essenciais (sempre ativos)
                          </p>
                          <p className="text-xs text-muted-foreground">
                            Autenticação, segurança e preferências básicas.
                            Inclui o registro de falhas técnicas, sem
                            identificar você, para manter a plataforma no ar.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-2">
                        <Icon
                          name="BarChart2"
                          size={14}
                          className="text-primary mt-0.5 flex-shrink-0"
                        />
                        <div>
                          <p className="text-xs font-medium text-foreground">
                            Analíticos (com consentimento)
                          </p>
                          <p className="text-xs text-muted-foreground">
                            Métricas de uso anônimas para melhorar a plataforma
                            (PostHog, Firebase Analytics).
                          </p>
                        </div>
                      </div>
                      <div className="pt-1">
                        <a
                          href="https://isugar.com.br/politica-de-privacidade.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs text-primary underline underline-offset-2"
                        >
                          Ver Política de Privacidade completa →
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                {/* Botões — mesmo peso visual e alvo de toque de 44px.
                    O "X" foi removido: fechar não pode ser um atalho
                    ambíguo para "recusar". */}
                <div className="flex flex-row md:flex-col gap-2 flex-shrink-0 md:min-w-[172px]">
                  <button
                    onClick={accept}
                    className="flex-1 md:flex-none min-h-[44px] bg-primary text-primary-foreground text-sm font-semibold px-4 rounded-lg hover:bg-primary/90 active:scale-[0.98] transition-all duration-150 whitespace-nowrap"
                  >
                    Aceitar todos
                  </button>
                  <button
                    onClick={decline}
                    className="flex-1 md:flex-none min-h-[44px] bg-transparent border border-border text-foreground text-sm font-semibold px-4 rounded-lg hover:bg-muted active:scale-[0.98] transition-all duration-150 whitespace-nowrap"
                  >
                    Só essenciais
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
